import { schemas } from "@convergence/client";
import { useMutation } from "@tanstack/react-query";
import { fetch } from "../fetch";


export function signupAnon(token: string) {
  return fetch(
    "/auth/anon",
    {
      method: "POST",
      headers: {
        "x-captcha-token": token,
      },
    },
    schemas.LoginResponse
  );
}

export const useSignupAnon = () => {
  const m = useMutation({
    mutationFn: (token: string) => signupAnon(token),
    mutationKey: ["signupAnon"],
  });
  return { ...m, signupAnon: m.mutateAsync };
};
